import React from "react";

// Хоёр оргилтой жижиг тэмдэг — хэсгийн гарчгийн дээрх чимэглэл
export const PeakMark = ({ className = "" }) => (
  <svg viewBox="0 0 24 14" className={className} aria-hidden="true">
    <path d="M0 14L8 3l4 5 4-8 8 14z" fill="currentColor" />
  </svg>
);

export const Eyebrow = ({ children, className = "" }) => (
  <span className={`inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-primary ${className}`}>
    <PeakMark className="w-5 h-3" /> {children}
  </span>
);

// Нүүр хуудасны хэсгүүдийн голлуулсан гарчиг
const SectionHeading = ({ eyebrow, title, subtitle, className = "" }) => (
  <div className={`max-w-2xl mx-auto text-center mb-12 ${className}`}>
    <Eyebrow>{eyebrow}</Eyebrow>
    <h2 className="mt-3 font-display text-3xl md:text-4xl font-extrabold text-foreground">{title}</h2>
    {subtitle && <p className="mt-3 text-lg text-muted-foreground">{subtitle}</p>}
  </div>
);

export default SectionHeading;
